const state = {
  layout: 'default',
  title: ''
}

const mutations = {
  setLayout (state, payload) {
    state.layout = payload
  },
  setTitle (state, payload) {
    state.title = payload
    document.title = state.title
  }
}

const getters = {
  layout: state => {
    return state.layout
  },
  title: state => {
    return state.title
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/pages.js